@import '../fluid-footer.theme.less'; // TODO: CHANGE THIS TO SEPARATE THEME TOKENS FILE


// ================================================================ //
// -- Theme Definition

:host {
  display: block;

  *, ::after, ::before {
    box-sizing: border-box;
  }

  .fluid-footer-content {

    /**
     * LEGACY THEME
     */
    &.legacy {
      @import '../../../styles/variables-iuw-legacy.less';
      @footer-content-tokens: @footer-tokens-legacy; // TODO: CHANGE THIS
      @footer-content();
    }

    /**
     * LIBERTY MUTUAL THEME
     */
    &.lm {
      @import '../../../styles/variables-lm.less';
      @footer-content-tokens: @footer-tokens-lm; // TODO: CHANGE THIS
      @footer-content();
    }

    /**
     * LM CORPORATE THEME
     */
    &.corp, &.default {
      @import '../../../styles/variables-lm-corp.less';
      @footer-content-tokens: @footer-tokens-corp; // TODO: CHANGE THIS
      @footer-content();
    }

    /**
     * PORTAL THEME
     */
    &.portal {
      @import '../../../styles/variables-lm-portal.less';
      @footer-content-tokens: @footer-tokens-portal; // TODO: CHANGE THIS
      @footer-content();
    }
  }
}


// ================================================================ //
// -- Component Detached Ruleset

@footer-content: {
  font-family: @font-family;
  font-size: @footer-content-tokens[font-size];
  line-height: @footer-content-tokens[line-height];
  color: @footer-content-tokens[color];
  padding: @padding-container;
};
